import { render, staticRenderFns } from "./mediationStatistics.vue?vue&type=template&id=0a6516a0&scoped=true"
import script from "./mediationStatistics.vue?vue&type=script&lang=js"
export * from "./mediationStatistics.vue?vue&type=script&lang=js"
import style0 from "./mediationStatistics.vue?vue&type=style&index=0&id=0a6516a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6516a0",
  null
  
)

export default component.exports